<script setup>
import { useRoute, useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';

import Policy from 'dashboard/components/policy.vue';
import Button from 'dashboard/components-next/button/Button.vue';
import TolaSignal from 'dashboard/components-next/empty-state/TolaSignal.vue';

const { t } = useI18n();
const route = useRoute();
const router = useRouter();

const setupVoiceChannel = () => {
  router.push({
    name: 'settings_inbox_new',
    params: { accountId: route.params.accountId },
  });
};
</script>

<template>
  <section
    class="flex flex-col items-center justify-center w-full h-full px-6 py-16 text-center bg-n-surface-1"
  >
    <TolaSignal icon="i-lucide-phone" />
    <h2 class="mt-4 mb-0 text-heading-2 text-n-slate-12">
      {{ t('CALLS_PAGE.SETUP.TITLE') }}
    </h2>
    <p class="max-w-md mt-2 mb-0 text-sm text-n-slate-11">
      {{ t('CALLS_PAGE.SETUP.SUBTITLE') }}
    </p>
    <Policy :permissions="['administrator']">
      <Button
        :label="t('CALLS_PAGE.SETUP.ACTION')"
        icon="i-lucide-plus"
        class="mt-6"
        @click="setupVoiceChannel"
      />
    </Policy>
  </section>
</template>
